import { LOGIN_USER, LOGOUT_USER } from './modules/user/types'

export const mutations = {
  INITIALIZED(state, value) {
    state.initialized = value
  },

  [LOGIN_USER](state, { user, perfis }) {
    state.isLogged = true
    state.initialized = true
    state.user = { ...user, perfis }
  },

  [LOGOUT_USER](state) {
    state.user = {}
    state.isLogged = false
    state.initialized = false
  },

  CLEAR_MODULES(state, value) {
    state.user = {}
    state.escala.funcionarios = []
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js